import React from "react";
import LocationContainer from "./LocationContainer";

const FastBuildingContainer: React.FC = () => <LocationContainer tool="FAST" />;

export default FastBuildingContainer;
